const LoadingSVG: React.FC = () => {
  return (
    <svg
      style={{ width: 206, height: 125 }}
      viewBox="0 0 206 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18:2586)">
        <path
          d="M17.054 27.1194C22.917 27.1194 27.67 22.3591 27.67 16.487C27.67 10.6149 22.917 5.85464 17.054 5.85464C11.1909 5.85464 6.43796 10.6149 6.43796 16.487C6.43796 22.3591 11.1909 27.1194 17.054 27.1194Z"
          fill="#FF6584"
        />
        <path
          d="M102.468 125C159.06 125 204.937 123.137 204.937 120.84C204.937 118.542 159.06 116.679 102.468 116.679C45.8766 116.679 0 118.542 0 120.84C0 123.137 45.8766 125 102.468 125Z"
          fill="#E6E6E6"
        />
        <path
          d="M26.0785 68.6988C40.4812 68.6988 52.1569 57.0051 52.1569 42.5802C52.1569 28.1553 40.4812 16.4615 26.0785 16.4615C11.6757 16.4615 0 28.1553 0 42.5802C0 57.0051 11.6757 68.6988 26.0785 68.6988Z"
          fill="#0033C6"
        />
        <path
          d="M28.5922 121.251H23.2507L25.6857 38.6465L28.5922 121.251Z"
          fill="#3F3D56"
        />
        <path
          d="M26.1569 54.302L31.8912 46.3564L26.0785 56.2687L25.45 55.1674L26.1569 54.302Z"
          fill="#3F3D56"
        />
        <path
          d="M25.5285 62.3264L19.7945 54.3808L25.6072 64.2931L26.2356 63.1918L25.5285 62.3264Z"
          fill="#3F3D56"
        />
        <path
          d="M190.974 121.338H185.633L188.068 38.7334L190.974 121.338Z"
          fill="#3F3D56"
        />
        <path
          d="M188.539 54.3889L194.273 46.4433L188.461 56.3557L187.832 55.2543L188.539 54.3889Z"
          fill="#3F3D56"
        />
        <path
          d="M187.911 62.4133L182.177 54.4677L187.989 64.38L188.618 63.2787L187.911 62.4133Z"
          fill="#3F3D56"
        />
        <path
          d="M105.942 121.324C132.773 121.324 154.523 99.54 154.523 72.6683C154.523 45.7967 132.773 24.0129 105.942 24.0129C79.1119 24.0129 57.3616 45.7967 57.3616 72.6683C57.3616 99.54 79.1119 121.324 105.942 121.324Z"
          fill="#3F3D56"
        />
        <path
          d="M105.942 117.296C130.551 117.296 150.501 97.3155 150.501 72.6683C150.501 48.0212 130.551 28.0407 105.942 28.0407C81.3329 28.0407 61.3831 48.0212 61.3831 72.6683C61.3831 97.3155 81.3329 117.296 105.942 117.296Z"
          fill="white"
        />
        <path
          d="M105.781 78.7905C109.068 78.7905 111.733 76.1216 111.733 72.8294C111.733 69.5372 109.068 66.8683 105.781 66.8683C102.494 66.8683 99.8294 69.5372 99.8294 72.8294C99.8294 76.1216 102.494 78.7905 105.781 78.7905Z"
          fill="#3F3D56"
        />
        <path
          d="M107.068 30.2962H104.494V35.1295H107.068V30.2962Z"
          fill="#3F3D56"
        />
        <path
          d="M107.068 110.529H104.494V115.363H107.068V110.529Z"
          fill="#3F3D56"
        />
        <path
          d="M68.1394 74.1183V71.5405H63.3135V74.1183H68.1394Z"
          fill="#3F3D56"
        />
        <path
          d="M148.249 74.1183V71.5405H143.423V74.1183H148.249Z"
          fill="#3F3D56"
        />
        <path
          d="M104.065 75.4171L106.265 70.3799L133.826 85.6679L104.065 75.4171Z"
          fill="#3F3D56"
        />
        <path
          d="M112.216 12.2518H99.6685V26.7518H112.216V12.2518Z"
          fill="#3F3D56"
        />
        <path
          d="M105.942 16.2796C113.938 16.2796 120.42 14.4763 120.42 12.2518C120.42 10.0273 113.938 8.22403 105.942 8.22403C97.9464 8.22403 91.4645 10.0273 91.4645 12.2518C91.4645 14.4763 97.9464 16.2796 105.942 16.2796Z"
          fill="#3F3D56"
        />
        <path
          d="M133.048 81.2877L132.243 82.4155C132.243 82.4155 128.543 86.7655 128.383 84.6711C128.222 82.5766 131.117 81.1266 131.117 81.1266L132.726 80.16L133.048 81.2877Z"
          fill="#FFB8B8"
        />
        <path
          d="M155.946 85.0926L156.619 86.3033C156.619 86.3033 158.961 91.514 157.002 90.7633C155.044 90.0126 154.974 86.771 154.974 86.771L154.79 84.9012L155.946 85.0926Z"
          fill="#FFB8B8"
        />
        <path
          d="M152.324 63.6246C155.03 63.6246 157.223 61.4283 157.223 58.7189C157.223 56.0095 155.03 53.8132 152.324 53.8132C149.619 53.8132 147.426 56.0095 147.426 58.7189C147.426 61.4283 149.619 63.6246 152.324 63.6246Z"
          fill="#2F2E41"
        />
        <path
          d="M151.869 99.0098L152.512 103.199V104.488H156.212V102.876C156.212 102.876 156.373 99.9765 155.729 99.1709C155.086 98.3654 151.869 99.0098 151.869 99.0098Z"
          fill="#FFB8B8"
        />
        <path
          d="M145.273 99.0098L145.917 103.199V104.488H149.616V102.876C149.616 102.876 149.777 99.9765 149.134 99.1709C148.49 98.3654 145.273 99.0098 145.273 99.0098Z"
          fill="#FFB8B8"
        />
        <path
          d="M147.763 65.3624C147.763 65.3624 146.34 66.1136 147.312 67.8223C148.284 69.5311 153.987 87.2094 153.987 87.2094L157.277 86.274L154.375 75.0938L152.714 68.0668L147.763 65.3624Z"
          fill="#0033C6"
        />
        <path
          d="M151.788 63.8072C153.831 63.8072 155.488 62.1482 155.488 60.1017C155.488 58.0551 153.831 56.3961 151.788 56.3961C149.745 56.3961 148.088 58.0551 148.088 60.1017C148.088 62.1482 149.745 63.8072 151.788 63.8072Z"
          fill="#FFB8B8"
        />
        <path
          d="M153.477 60.6655L152.995 68.2377L149.616 65.8211C149.616 65.8211 150.743 61.31 150.421 60.9877L153.477 60.6655Z"
          fill="#FFB8B8"
        />
        <path
          d="M153.477 67.5933L149.838 64.8943C149.838 64.8943 148.169 64.21 147.686 65.0155C147.203 65.8211 144.791 77.7433 146.077 79.9989C146.077 79.9989 152.995 81.4489 154.442 80.6433L155.086 76.4544C155.086 76.4544 155.89 73.8766 154.603 72.2655L153.477 67.5933Z"
          fill="#0033C6"
        />
        <path
          d="M148.651 65.1766C148.651 65.1766 147.364 64.2099 146.238 65.8211C145.112 67.4322 131.6 80.1599 131.6 80.1599L133.852 82.7377L142.699 75.3266L148.33 70.8155L148.651 65.1766Z"
          fill="#0033C6"
        />
        <path
          d="M154.523 80.5626C154.523 80.5626 146.56 79.0321 145.756 80.1599L145.595 81.9321C145.595 81.9321 143.825 85.3154 144.791 90.7932C145.756 96.2709 145.112 99.6543 145.112 99.6543C145.112 99.6543 149.456 99.1709 152.673 99.6543C155.89 100.138 156.373 99.6543 156.373 99.6543L154.523 80.5626Z"
          fill="#2F2E41"
        />
        <path
          d="M156.534 103.843L151.869 104.004L153.477 116.088C153.477 116.088 152.19 121.243 153.638 121.565C154.644 121.769 155.668 121.877 156.694 121.888C156.694 121.888 158.142 123.338 159.751 123.176C160.819 123.04 161.854 122.712 162.807 122.21C162.807 122.21 163.129 121.243 162.003 120.921C160.877 120.599 157.82 119.632 157.177 116.249L156.534 103.843Z"
          fill="#2F2E41"
        />
        <path
          d="M149.938 103.843L145.273 104.004L146.882 116.088C146.882 116.088 145.595 121.243 147.043 121.565C148.049 121.769 149.072 121.877 150.099 121.888C150.099 121.888 151.547 123.338 153.155 123.176C154.224 123.04 155.259 122.712 156.212 122.21C156.212 122.21 156.534 121.243 155.408 120.921C154.281 120.599 151.225 119.632 150.582 116.249L149.938 103.843Z"
          fill="#2F2E41"
        />
        <path
          d="M154.038 55.5856C155.157 55.5856 156.065 54.6768 156.065 53.5557C156.065 52.4346 155.157 51.5257 154.038 51.5257C152.918 51.5257 152.011 52.4346 152.011 53.5557C152.011 54.6768 152.918 55.5856 154.038 55.5856Z"
          fill="#2F2E41"
        />
        <path
          d="M156.74 52.4561C156.74 51.9543 156.555 51.4704 156.219 51.0975C155.884 50.7247 155.423 50.4894 154.925 50.4371C154.995 50.4298 155.065 50.4262 155.136 50.4261C155.673 50.4261 156.189 50.64 156.569 51.0207C156.949 51.4014 157.163 51.9177 157.163 52.4561C157.163 52.9945 156.949 53.5108 156.569 53.8915C156.189 54.2722 155.673 54.4861 155.136 54.4861C155.065 54.486 154.995 54.4824 154.925 54.4751C155.423 54.4228 155.884 54.1875 156.219 53.8147C156.555 53.4419 156.74 52.9579 156.74 52.4561Z"
          fill="#2F2E41"
        />
        <path
          d="M151.755 59.7087C153.62 59.7087 155.133 58.7999 155.133 57.6788C155.133 56.5577 153.62 55.6488 151.755 55.6488C149.889 55.6488 148.377 56.5577 148.377 57.6788C148.377 58.7999 149.889 59.7087 151.755 59.7087Z"
          fill="#2F2E41"
        />
        <path
          d="M204.963 9.74279C204.825 7.2994 203.825 4.9845 202.141 3.21081C200.458 1.43713 198.2 0.319965 195.77 0.0584886C193.341 -0.202988 190.897 0.408227 188.876 1.78315C186.855 3.15808 185.386 5.20735 184.733 7.5656C184.608 7.56111 184.483 7.55608 184.357 7.55608C182.13 7.55649 179.962 8.27925 178.179 9.61623C176.396 10.9532 175.093 12.8325 174.465 14.9731C172.989 14.3235 171.339 14.1826 169.774 14.5723C168.21 14.9621 166.818 15.8606 165.818 17.1271H197.981C198.919 17.1297 199.848 16.9427 200.713 16.5773C201.577 16.2118 202.359 15.6754 203.011 15.0002C203.664 14.325 204.174 13.5248 204.51 12.6476C204.847 11.7704 205.003 10.8342 204.97 9.89508C204.968 9.84439 204.966 9.79363 204.963 9.74279Z"
          fill="#E6E6E6"
        />
        <path
          d="M178.075 31.476C179.605 31.476 180.845 30.2342 180.845 28.7023C180.845 27.1705 179.605 25.9286 178.075 25.9286C176.546 25.9286 175.306 27.1705 175.306 28.7023C175.306 30.2342 176.546 31.476 178.075 31.476Z"
          fill="#E6E6E6"
        />
        <path
          d="M186.437 24.4724C187.711 24.4724 188.743 23.4384 188.743 22.1629C188.743 20.8874 187.711 19.8534 186.437 19.8534C185.164 19.8534 184.131 20.8874 184.131 22.1629C184.131 23.4384 185.164 24.4724 186.437 24.4724Z"
          fill="#E6E6E6"
        />
        <path
          d="M197.692 37.4855C199.221 37.4855 200.461 36.2437 200.461 34.7119C200.461 33.18 199.221 31.9382 197.692 31.9382C196.162 31.9382 194.922 33.18 194.922 34.7119C194.922 36.2437 196.162 37.4855 197.692 37.4855Z"
          fill="#E6E6E6"
        />
        <path
          d="M176.691 50.1981C178.22 50.1981 179.46 48.9563 179.46 47.4245C179.46 45.8926 178.22 44.6508 176.691 44.6508C175.161 44.6508 173.921 45.8926 173.921 47.4245C173.921 48.9563 175.161 50.1981 176.691 50.1981Z"
          fill="#E6E6E6"
        />
        <path
          d="M197.692 66.1467C199.221 66.1467 200.461 64.9049 200.461 63.373C200.461 61.8412 199.221 60.5994 197.692 60.5994C196.162 60.5994 194.922 61.8412 194.922 63.373C194.922 64.9049 196.162 66.1467 197.692 66.1467Z"
          fill="#E6E6E6"
        />
        <path
          d="M193.302 116.856C193.303 116.826 193.307 116.796 193.307 116.766C193.308 116.301 193.192 115.844 192.969 115.436C192.747 115.028 192.426 114.682 192.035 114.431C191.645 114.18 191.198 114.031 190.735 113.999C190.272 113.967 189.808 114.051 189.387 114.245C188.991 113.788 188.456 113.473 187.865 113.349C187.274 113.225 186.658 113.299 186.112 113.559C185.567 113.819 185.121 114.251 184.844 114.789C184.567 115.327 184.474 115.941 184.579 116.537C184.565 116.537 184.551 116.535 184.537 116.535C184.096 116.534 183.662 116.639 183.269 116.84C182.877 117.042 182.538 117.334 182.282 117.693C182.025 118.052 181.857 118.467 181.793 118.904C181.729 119.341 181.77 119.787 181.912 120.205C182.054 120.622 182.294 121 182.612 121.307C182.93 121.613 183.316 121.839 183.738 121.965C184.16 122.092 184.607 122.116 185.04 122.035C185.474 121.954 185.881 121.771 186.23 121.5C186.45 121.929 186.777 122.293 187.181 122.557C187.584 122.82 188.049 122.973 188.529 123.002C189.01 123.03 189.489 122.933 189.921 122.719C190.352 122.505 190.72 122.182 190.989 121.782C191.318 122.022 191.697 122.186 192.097 122.263C192.497 122.339 192.91 122.327 193.304 122.225C193.699 122.124 194.067 121.936 194.381 121.676C194.695 121.416 194.947 121.09 195.121 120.72C195.294 120.351 195.384 119.948 195.384 119.54C195.384 119.132 195.294 118.728 195.12 118.359C194.946 117.99 194.693 117.664 194.379 117.404C194.065 117.144 193.697 116.957 193.302 116.856Z"
          fill="#E6E6E6"
        />
        <path
          d="M200.23 53.4341C200.868 53.4341 201.384 52.9166 201.384 52.2784C201.384 51.6401 200.868 51.1227 200.23 51.1227C199.593 51.1227 199.077 51.6401 199.077 52.2784C199.077 52.9166 199.593 53.4341 200.23 53.4341Z"
          fill="#E6E6E6"
        />
        <path
          d="M192.845 25.6975C193.483 25.6975 193.999 25.1801 193.999 24.5418C193.999 23.9035 193.483 23.3861 192.845 23.3861C192.208 23.3861 191.691 23.9035 191.691 24.5418C191.691 25.1801 192.208 25.6975 192.845 25.6975Z"
          fill="#E6E6E6"
        />
        <path
          d="M188.922 54.3586C189.559 54.3586 190.076 53.8412 190.076 53.2029C190.076 52.5647 189.559 52.0472 188.922 52.0472C188.285 52.0472 187.768 52.5647 187.768 53.2029C187.768 53.8412 188.285 54.3586 188.922 54.3586Z"
          fill="#E6E6E6"
        />
        <path
          d="M189.845 53.2029C190.482 53.2029 190.999 52.6855 190.999 52.0472C190.999 51.409 190.482 50.8915 189.845 50.8915C189.208 50.8915 188.691 51.409 188.691 52.0472C188.691 52.6855 189.208 53.2029 189.845 53.2029Z"
          fill="#E6E6E6"
        />
        <path
          d="M190.538 52.0473C191.175 52.0473 191.691 51.5298 191.691 50.8916C191.691 50.2533 191.175 49.7359 190.538 49.7359C189.9 49.7359 189.384 50.2533 189.384 50.8916C189.384 51.5298 189.9 52.0473 190.538 52.0473Z"
          fill="#E6E6E6"
        />
        <path
          d="M187.768 61.7551C188.405 61.7551 188.922 61.2376 188.922 60.5994C188.922 59.9611 188.405 59.4437 187.768 59.4437C187.131 59.4437 186.614 59.9611 186.614 60.5994C186.614 61.2376 187.131 61.7551 187.768 61.7551Z"
          fill="#E6E6E6"
        />
        <path
          d="M204.846 74.6988C205.483 74.6988 206 74.1814 206 73.5431C206 72.9049 205.483 72.3875 204.846 72.3875C204.209 72.3875 203.692 72.9049 203.692 73.5431C203.692 74.1814 204.209 74.6988 204.846 74.6988Z"
          fill="#E6E6E6"
        />
        <path
          d="M180.152 75.3922C180.79 75.3922 181.306 74.8748 181.306 74.2365C181.306 73.5982 180.79 73.0808 180.152 73.0808C179.515 73.0808 178.998 73.5982 178.998 74.2365C178.998 74.8748 179.515 75.3922 180.152 75.3922Z"
          fill="#E6E6E6"
        />
        <path
          d="M181.537 39.7969C182.174 39.7969 182.691 39.2795 182.691 38.6412C182.691 38.003 182.174 37.4855 181.537 37.4855C180.9 37.4855 180.383 38.003 180.383 38.6412C180.383 39.2795 180.9 39.7969 181.537 39.7969Z"
          fill="#E6E6E6"
        />
        <path
          d="M186.845 60.5993C187.482 60.5993 187.999 60.0819 187.999 59.4437C187.999 58.8054 187.482 58.288 186.845 58.288C186.208 58.288 185.691 58.8054 185.691 59.4437C185.691 60.0819 186.208 60.5993 186.845 60.5993Z"
          fill="#E6E6E6"
        />
        <path
          d="M185.691 58.7502C186.328 58.7502 186.845 58.2328 186.845 57.5945C186.845 56.9563 186.328 56.4388 185.691 56.4388C185.054 56.4388 184.537 56.9563 184.537 57.5945C184.537 58.2328 185.054 58.7502 185.691 58.7502Z"
          fill="#E6E6E6"
        />
      </g>
      <defs>
        <clipPath id="clip0_18:2586">
          <rect width="206" height="125" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LoadingSVG;
